/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

import { useMsal } from '@azure/msal-react';
import { useAuthStore } from '../../stores/authStore';

export function Header() {
  const { instance } = useMsal();
  const user = useAuthStore((s) => s.user);

  const handleSignOut = () => {
    instance.logoutRedirect();
  };

  return (
    <header className="bg-dds-blue-500 text-white h-14 flex items-center px-4 shrink-0">
      <img
        src="/logo.png"
        alt="Dobler Data Solutions"
        className="h-8 w-auto mr-3"
      />
      <h1 className="font-semibold text-lg mr-auto">DataMave Formulary</h1>
      {user && (
        <div className="flex items-center gap-3">
          <span className="text-sm text-blue-100">{user.name}</span>
          <span className="text-xs bg-dds-blue-600 px-2 py-0.5 rounded">
            {user.role || 'No Role'}
          </span>
          <button
            onClick={handleSignOut}
            className="text-sm text-blue-200 hover:text-white transition-colors"
          >
            Sign out
          </button>
        </div>
      )}
    </header>
  );
}
